// Marketing site has no logged-in phone signal — Hebrew is gated by IP only.
export const shouldShowHebrew = ({ ipCountry } = {}) =>
  !!ipCountry && String(ipCountry).toUpperCase() === 'IL';

export const filterByHebrewFlag = (list, showHebrew, getCode = (x) => x) =>
  showHebrew ? list : list.filter((item) => getCode(item) !== 'he');
